"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _requiredRed = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/required-red"));

var _throbberLight = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/throbber-light"));

var _Button = _interopRequireDefault(require("../Button/Button"));

require("./ContinueButton.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var noop = function noop() {};

var ContinueButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ContinueButton, _Component);

  var _super = _createSuper(ContinueButton);

  function ContinueButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContinueButton);
    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ContinueButton, [{
    key: "handleClick",
    value: function handleClick(e) {
      if (!this.props.enabled || this.props.isLoading) {
        return;
      }

      this.props.onClick(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          buttonLabel = _this$props.buttonLabel,
          loadingLabel = _this$props.loadingLabel,
          enabled = _this$props.enabled,
          isLoading = _this$props.isLoading,
          showValidationInfo = _this$props.showValidationInfo,
          className = _this$props.className,
          type = _this$props.type;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "continue-button-container ".concat(className)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "button"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: type,
        role: "button",
        onClick: this.handleClick,
        disabled: !enabled || isLoading
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "button-label"
      }, isLoading && /*#__PURE__*/_react.default.createElement(_throbberLight.default, {
        noPad: true,
        className: "spinner"
      }), isLoading ? loadingLabel : buttonLabel))), showValidationInfo && /*#__PURE__*/_react.default.createElement("div", {
        className: "info text-center"
      }, /*#__PURE__*/_react.default.createElement(_requiredRed.default, null), " All items marked with a red asterisk are required to submit this form."));
    }
  }], [{
    key: "propTypes",
    value: function propTypes() {
      return {
        buttonLabel: _propTypes.default.string,
        loadingLabel: _propTypes.default.string,
        onClick: _propTypes.default.func,
        enabled: _propTypes.default.bool,
        isLoading: _propTypes.default.bool,
        showValidationInfo: _propTypes.default.bool,
        className: _propTypes.default.string,
        type: _propTypes.default.oneOf(['button', 'submit', 'reset'])
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        buttonLabel: 'CONTINUE',
        loadingLabel: 'LOADING',
        onClick: noop,
        enabled: true,
        isLoading: false,
        showValidationInfo: true,
        className: '',
        type: 'submit'
      };
    }
  }]);
  return ContinueButton;
}(_react.Component);

exports.default = ContinueButton;